import styled from "styled-components";
import { StyledTableProps } from "./Table.types";

export const StyledTable = styled.table<StyledTableProps>`
	text-align: left;
	border-spacing: 0px;
	border-collapse: separate;
	overflow: hidden;
	white-space: nowrap;

	tr:last-of-type > td {
		border: none;
	}

	${({ theme, outlined, colorOn }) => {
		const isOnDarkBackground = colorOn.includes("dark");

		return {
			border: outlined ? "1px solid" : "none",
			borderColor: isOnDarkBackground
				? theme.palette.hexForMandatory("neutral_300")
				: theme.palette.hexForMandatory("neutral_500"),
			borderRadius: theme.radii.lg,

			"th, td": {
				borderBottom: "1px solid",
				borderBottomColor: isOnDarkBackground
					? theme.palette.hexForMandatory("neutral_300")
					: theme.palette.hexForMandatory("neutral_500"),
				padding: `${theme.space.xl} ${theme.space.lg}`,
			},
			thead: {
				backgroundColor: outlined
					? isOnDarkBackground
						? theme.palette.hexForMandatory("neutral_800")
						: theme.palette.hexForMandatory("neutral_200")
					: "transparent",

				color: isOnDarkBackground
					? theme.palette.hexForMandatory("white")
					: theme.palette.hexForRole("fg_dark_1"),
			},
			tbody: {
				color: isOnDarkBackground
					? theme.palette.hexForRole("fg_light_2")
					: theme.palette.hexForRole("fg_dark_2"),
			},
			...(!outlined && {
				td: {
					borderBottom: "none",
				},
			}),
		};
	}}
`;
